/* =========================================================================
   720 EGONEX — Ürün kartı davranışları
   - Dönen avantaj şeridi
   - Görsel dairelerine tıklayınca ana görsel değişir
   - Sepete ekle (çekmeceyi AÇMADAN ekler, butonda "Eklendi" gösterir)
   ========================================================================= */
(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = window.matchMedia('(hover: none)').matches;

  /* ---------------------------------------------- DÖNEN AVANTAJ ŞERİDİ */
  function initPerks(root) {
    (root || document).querySelectorAll('[data-eg-perks]').forEach((box, idx) => {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';

      const items = Array.from(box.querySelectorAll('.eg-pc__perk'));
      if (items.length < 2) return;

      const interval = parseInt(box.dataset.interval, 10) || 3000;
      let i = 0;
      let timer = null;

      const tick = () => {
        const prev = items[i];
        i = (i + 1) % items.length;
        const next = items[i];
        prev.classList.add('is-leaving');
        prev.classList.remove('is-active');
        setTimeout(() => prev.classList.remove('is-leaving'), 450);
        next.classList.add('is-active');
      };

      const start = () => {
        if (reduced || timer) return;
        // Kartlar aynı anda dönmesin diye her kart biraz kaydırılır
        timer = setInterval(tick, interval);
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => (en.isIntersecting ? setTimeout(start, (idx % 5) * 350) : stop()));
      });
      io.observe(box);
    });
  }

  /* -------------------------------------------------- GÖRSEL DAİRELERİ */
  function initThumbs(root) {
    (root || document).querySelectorAll('[data-eg-thumbs]').forEach((wrap) => {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';

      const card = wrap.closest('.eg-pc');
      const main = card && card.querySelector('.eg-pc__img--main');
      if (!main) return;

      const buttons = Array.from(wrap.querySelectorAll('button.eg-pc__thumb'));
      const swap = (btn) => {
        const src = btn.dataset.src;
        if (!src || main.src === src) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = src;
        buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
      };

      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          swap(btn);
        });
        if (!isTouch) btn.addEventListener('pointerenter', () => swap(btn));
      });
    });
  }

  /* ----------------------------------------------------- SEPETE EKLE */
  function getSectionInner(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function initAdd(root) {
    (root || document).querySelectorAll('[data-eg-add]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

        const id = btn.getAttribute('data-eg-add');
        const textEl = btn.querySelector('.eg-pc__add-text');
        btn.classList.remove('is-error');
        btn.classList.add('is-loading');

        try {
          const res = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: Number(id), quantity: 1 }],
              sections: 'cart-icon-bubble,cart-drawer',
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);

          /* --- Header sepet balonu --- */
          if (data.sections && data.sections['cart-icon-bubble']) {
            const target = document.getElementById('cart-icon-bubble');
            const source = getSectionInner(data.sections['cart-icon-bubble'], '.shopify-section');
            if (target && source) target.innerHTML = source.innerHTML;
          }

          /* --- Sepet çekmecesinin içeriğini tazele (AÇMADAN) --- */
          if (data.sections && data.sections['cart-drawer']) {
            const dst = document.getElementById('CartDrawer');
            const src = getSectionInner(data.sections['cart-drawer'], '#CartDrawer');
            if (dst && src) {
              dst.innerHTML = src.innerHTML;
              const drawer = document.querySelector('cart-drawer');
              if (drawer) {
                drawer.classList.remove('is-empty');
                const overlay = dst.querySelector('#CartDrawer-Overlay');
                if (overlay) overlay.addEventListener('click', () => drawer.close());
              }
              window.egRebindCart?.();
            }
          }

          window.egSyncCartCount?.();

          /* --- Buton durumu --- */
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (textEl) textEl.textContent = btn.dataset.added || 'Eklendi';

          if (btn.dataset.toast === 'true' && window.egToast) {
            window.egToast(btn.dataset.added || 'Sepete eklendi', 'success');
          }

          clearTimeout(btn._t);
          btn._t = setTimeout(() => {
            btn.classList.remove('is-added');
            if (textEl) textEl.textContent = btn.dataset.label || 'Sepete Ekle';
          }, parseInt(btn.dataset.resetAfter, 10) || 2600);
        } catch (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          if (textEl) textEl.textContent = 'Eklenemedi';
          setTimeout(() => {
            btn.classList.remove('is-error');
            if (textEl) textEl.textContent = btn.dataset.label || 'Sepete Ekle';
          }, 2600);
        }
      });
    });
  }

  /* ------------------------------------------------------------ BAŞLAT */
  function init(root) {
    initPerks(root);
    initThumbs(root);
    initAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target || document));

  // Sonradan DOM'a giren kartlar (filtreleme, sonsuz yükleme, hızlı görüntüleme)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.matches?.('.eg-pc, .eg-pc-wrap') || n.querySelector?.('.eg-pc'))) {
          init(n);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
